import moment from 'moment';

export class BookingsService {
    /**
     * Generate the week view
     * @param selectedDate
     * @returns {[]}
     */
    static generateDays(selectedDate) {
        const weekViewArray = [];
        for (let i = 0; i < 7; i++) {
            weekViewArray.push({
                day: moment(selectedDate).add(i, 'days').toDate(),
                bookings: [],
                dt: 0,
                ccm: 0,
                cca: 0,
                tdo: 0,
                tpu: 0,
                events: []
            })
        }
        return weekViewArray
    }

    /**
     *
     * @param events <Array>
     * @returns {[]}
     */
    static etlEvents(events) {
        const temp = [];
        if (events) {
            events.forEach(e => {
                if (e) {
                    const sd = e.startDate;
                    const ed = e.endDate;
                    const duration = moment(ed).diff(moment(sd), 'days');
                    for (let i = 0; i <= duration; i++) {
                        const ev = {
                            name: e.name,
                        };
                        ev.startDate = moment(e.startDate).add(i, 'days').format('YYYY-MM-DD');
                        temp.push(ev);
                    }
                }
            });
        }
        return temp;
    }

    /**
     * Adds any events to the Weekday
     * @param events
     * @param weekView
     * @returns {[]}
     */
    static addEventsToArray(events, weekView) {
        events.forEach(e => {
            weekView.forEach(m => {
                if (moment(e.startDate).isSame(moment(m.day))) {
                    m.events.push(e);
                }
            });
        });
        return weekView;
    }

    /**
     * Merges bookings into week view
     * @param bookings
     * @param weekView
     */
    static addBookingsToArray(bookings, weekView) {
        weekView.forEach(w => {
            if (bookings) {
                bookings.forEach(b => {
                    const start = new Date(b.startDate);
                    start.setHours(0);
                    if (moment(start).isSame(moment(w.day))) {
                        if (b.dailyTotals && b.dailyTotals[b.day -1] && b.dailyTotals[b.day -1].total) {
                            w.dt = w.dt + b.dailyTotals[b.day -1].total;
                        }
                        if (b.isCCar && b.ccTypeManual && b.dailyTotals[b.day -1] && b.dailyTotals[b.day -1].isCCar) {
                            w.ccm++;
                        }
                        if (b.isCCar && b.ccTypeAuto && b.dailyTotals[b.day -1] && b.dailyTotals[b.day -1].isCCar) {
                            w.cca++;
                        }

                        if (b.dailyTotals && b.dailyTotals[b.day -1].isDropOff) {
                            w.tdo++;
                        }
                        if (b.dailyTotals && b.dailyTotals[b.day -1].isPickUp) {
                            w.tpu++;
                        }
                        w.bookings.push(b);
                    }
                });
            }
        });
        return weekView;
    }
}
